// src/App.js
import React from 'react';
import Spirograph from './components/Spirograph';
//import Canvas from './components/Canvas-1';

const App = ({ isHomepage }) => {
  return (
    <div className='App'>
      <Spirograph isHomepage={isHomepage}/>
    </div>
  );
};

export default App;
